import { render, staticRenderFns } from "./PartnerSales.vue?vue&type=template&id=86657e72&scoped=true&"
import script from "./PartnerSales.vue?vue&type=script&lang=ts&"
export * from "./PartnerSales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86657e72",
  null
  
)

export default component.exports